import validate from 'validate';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    MAP_LIST
} from '$http';
import Uploader from 'uploader';
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    data() {
        return {
            payTypeData: this.refGetPayTypeData(),
            valid: false,
            posShow: false,
            isDelShow: false,
            PayTypes: [{
                "Id": 1,
                "ParmName": "支付宝"
            }, {
                "Id": 4,
                "ParmName": "微信"
            }, {
                "Id": 5,
                "ParmName": "pos机"
            }, {
                "Id": 8,
                "ParmName": "其他"
            }, {
                "Id": 6,
                "ParmName": "淘宝"
            }, {
                "Id": 9,
                "ParmName": "微店"
            }],
            PayTitle: "支付凭证单号",
            changePic: [],
        };
    },
    props: {
        isReadOnly: {
            default: false
        },
        myIndex: {
            default: 1
        },
        hasDelFn: {
            default: true
        },
        value: {
            type: Object,
            default: null
        },
        isLBHome: {
            default: false
        }
    },
    computed: {
        hasDelBtnShow() {
            if (this.isReadOnly) {
                return false;
            }
            if (!this.hasDelFn) {
                return false;
            }
            return true;
        },
        getbtnId() {
            return "btn_" + (new Date()).getTime()
        },
        getCtnId() {
            return "ctn_" + (new Date()).getTime()
        }
    },
    created() {
        // if (this.isLBHome) {
        //     this.PayTypes = [{
        //         "Id": 6,
        //         "ParmName": "淘宝"
        //     }, {
        //         "Id": 9,
        //         "ParmName": "微店"
        //     }]
        // } else {
        //     this.PayTypes = [{
        //         "Id": 1,
        //         "ParmName": "支付宝"
        //     }, {
        //         "Id": 4,
        //         "ParmName": "微信"
        //     }, {
        //         "Id": 5,
        //         "ParmName": "pos机"
        //     }, {
        //         "Id": 8,
        //         "ParmName": "其他"
        //     }]
        // }
        if (isCorrectVal(this.value)) {
            this.setValue();
            return;
        }
        this.payTypeData = this.refGetPayTypeData();


    },
    watch: {
        value: {
            deep: true,
            handler: function (val) {
                this.setValue();
            }
        }
    },
    mounted() {

        this.$nextTick(function () {

            var self = this;
            let uploaderFactory = new Uploader();
            let uploader1 = uploaderFactory.generator({
                container: this.getCtnId,
                browse_button: this.getbtnId,
                multi_selection: true, //上传多张
                //开始上传
                uploadBegin: function () {

                },
                //上传结束并得到文件
                uploaded: function (file) {
                    // console.log(self.changePic)
                    if (self.changePic == undefined) {
                        self.changePic = []
                    }
                    self.changePic.push(file)
                }
            });
            uploaderFactory.init();
        });

    },
    methods: {
        refGetPayTypeData() {
            return cloneDeep({
                PayWay: "",
                BankName: "",
                Trade_No: "",
                VoucherPic: "", //凭证图
                OrderActualPrice: "", //支付金额
                PayRemark: '' //支付说明
            });
        },
        clearData() {
            this.payTypeData = this.refGetPayTypeData();
        },
        resetFields() {
            this.$refs.form.resetFields();
            this.clearData();
        },
        deleteFn(index) {
            this.$emit('delPayfn', {
                index: index
            });
        },
        viewPicture(url, list) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: url,
                    id: ""
                }]
            });
        },
        delPicture(Url, list) {
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].Url == Url) {
                        list.splice(i, 1);
                    }
                }
            }
        },
        //选择支付方式
        changePayType(val) {
            if (val == 1) {
                this.PayTitle = "支付凭证单号"
                this.posShow = false
                this.payTypeData.PayRemark = ''
            } else if (val == 4) {
                this.PayTitle = "交易单号"
                this.posShow = false
                this.payTypeData.PayRemark = ''
            } else if (val == 5) {
                this.PayTitle = "流水号"
                this.posShow = true
                this.payTypeData.PayRemark = ''
            } else if (val == 6 || val == 9) {
                this.PayTitle = "支付订单号"
                this.posShow = false
                this.payTypeData.PayRemark = ''
            } else if (val == 8) {
                this.posShow = false
                this.payTypeData.Trade_No = ''
            }


        },
        setValue() {
            this.$nextTick(() => {
                let payTypeData = cloneDeep(this.value);
                this.changePic = []
                this.payTypeData = $.extend({}, this.refGetPayTypeData(), util.filterAndSetData(this.refGetPayTypeData(), payTypeData));
                this.isSetData = true;
                if (typeof (payTypeData.VoucherPic) !== 'string') {
                    this.changePic = cloneDeep(payTypeData.VoucherPic)
                } else {
                    if (payTypeData.VoucherPic) {
                        let pic = payTypeData.VoucherPic.split(',')
                        for (let i = 0; i < pic.length; i++) {
                            this.changePic.push({
                                "Url": pic[i]
                            })
                        }
                    }
                }
            });

        },
        validate() {
            let rules = [];
            rules.push({
                name: "支付方式",
                value: this.payTypeData.PayWay,
                required: true
            });
            if (this.payTypeData.PayWay !== 6 && this.payTypeData.PayWay !== 9) {
                rules.push({
                    name: "支付金额",
                    value: this.payTypeData.OrderActualPrice,
                    required: true
                })
            }
            if (!this.posShow && this.payTypeData.PayWay !== 8) {
                rules.push({
                    name: this.PayTitle,
                    value: this.payTypeData.Trade_No,
                    required: true
                });
            }
            if (this.payTypeData.PayWay == 8) {
                rules.push({
                    name: '支付说明',
                    value: this.payTypeData.PayRemark,
                    required: true
                });
            }
            let flag = util.checkForm({
                ele: this,
                rules: rules
            });
            if (this.posShow) {
                if (this.changePic == undefined) {
                    this.$notify({
                        title: '警告',
                        message: "请上传支付凭证",
                        type: 'warning'
                    });
                    return
                } else if (this.changePic.length <= 0) {
                    this.$notify({
                        title: '警告',
                        message: "请上传支付凭证",
                        type: 'warning'
                    });
                    return
                } else {
                    this.payTypeData.VoucherPic = this.changePic.map(item => item.Url).toString();

                }
            }
            if (flag) {
                return this.payTypeData;
            }
            return false;
        },
    },
};


// WEBPACK FOOTER //
// ./src/pages/Order/MeetOrder/components/payTypes/vm.js